import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=1a186938&scoped=true"
import script from "./checkbox-group.vue?vue&type=script&lang=js"
export * from "./checkbox-group.vue?vue&type=script&lang=js"
import style0 from "./checkbox-group.vue?vue&type=style&index=0&id=1a186938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a186938",
  null
  
)

export default component.exports